export enum FormQuestionType {
  Choice = 1,
  MultipleChoice = 2,
  TextBox = 3,
  File = 4,
  TextBoxOrChoice = 5,
}